<template>
  <div class="events">
    <v-list>
      <v-list-tile class="last24-title">
        <v-list-tile-content>
          <v-list-tile-title>EVENTOS DE LAS ULTIMAS 24 HS</v-list-tile-title>
        </v-list-tile-content>
        <v-list-tile-action class="last24-action">{{allEvents.length === []?0:timeSeriesData.length}}</v-list-tile-action>
      </v-list-tile>
      <div v-if="allEvents.length !== 0">

        <v-list-tile

          v-for="item in timeSeriesData"
          :key="item.title"
          avatar
          style="content-visibility: auto"

        >
          <v-list-tile-avatar>
            <svg class="svg-icon" xmlns="http://www.w3.org/2000/svg" v-if="item.type == 2">
              <rect y=10 x=4 :fill="item.color"/>
            </svg>
            <v-icon v-else small :color="item.color">trip_origin</v-icon>
          </v-list-tile-avatar>

          <v-list-tile-content>
            <strong><v-list-tile-title>{{item.name}}</v-list-tile-title></strong>
            <v-list-tile-sub-title></v-list-tile-sub-title>
          </v-list-tile-content>

          <v-list-tile-action class="last24-title">
            {{item.description}} - {{item.time}}
          </v-list-tile-action>
        </v-list-tile>
      </div>
    </v-list>

  </div>
</template>

<script>

import moment from 'moment';
import { ALL_DEVICES_TIMELINE_QUERY, USER_QUERY } from '../../constants/graphql';
import _orderBy from 'lodash/orderBy';
import { STATES, COLOR } from '../../constants/constants';

export default {
  data () {
    return {
      timeSeriesData: [],
      allEvents: [],
      skipEventsQuery: true,
      User: {}
    };
  },
  apollo: {
    User: {
      query: USER_QUERY,
      variables () {
        return {
          id: this.$store.getters.user.id
        };
      },
      result () {
        this.skipEventsQuery = false;
      },
      error () {
        this.skipEventsQuery = false;
      }
    },
    allEvents: {
      query: ALL_DEVICES_TIMELINE_QUERY,
      variables () {
        return {
          datetime: moment().subtract(1, 'days').toISOString(),
          organizationIds: this.User.Organization.map(org => org.id)
        };
      },
      skip () {
        return this.skipEventsQuery;
      },
      result () {
        this.setTimelineEvents();
      }
    }
  },
  computed: {
  },
  methods: {
    setTimelineEvents () {
      // Order events by time and filter irrigation orders
      const lastDayEvents = _orderBy(this.allEvents, ['dateTime'], ['desc']).filter(event => !event.note);
      this.timeSeriesData = lastDayEvents.map(event => ({
        time: moment(event.dateTime).format('HH:mm'),
        color: this.getIcon(event.State.value),
        description: event.State.label,
        name: event.Device.name,
        type: event.Device.DeviceType.id
      }));
    },
    getIcon (value) {
      switch (value) {
        case STATES.IRRIGATING:
          return COLOR.GREEN;
        case STATES.OFF:
          return COLOR.GREY;
        case STATES.FAILURE:
          return COLOR.RED;
        case STATES.MOVING:
          return COLOR.BLUE;
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// Events.vue?29f9d1f2